import React from 'react';
import clsx from 'clsx';
import { InfoTooltip } from '@/dashboard/components/Tooltip';

const Heading = ({ label, level = 2, className, tooltip, icon: Icon, ...props }) => {
  const HeadingTag = `h${level}`;

  const headingClasses = clsx(
    'font-semibold text-gray-900 dark:text-foreground',
    {
      'text-xl': level === 1,
      'text-lg': level === 2,
      'text-base font-semibold': level === 3,
      'text-sm font-semibold': level === 4,
      'text-sm': level === 5,
      'text-xs': level === 6,
    },
    className,
  );

  return (
    <HeadingTag className={clsx(headingClasses, Icon && 'flex items-center gap-2')} {...props}>
      {Icon && <Icon className="size-4 shrink-0" aria-hidden="true" />}
      {label}

      {tooltip && <InfoTooltip>{tooltip}</InfoTooltip>}
    </HeadingTag>
  );
};

export default Heading;
